// src/components/layout/CategoryShell.js
import React from "react";

function CategoryShell({ children }) {
  return (
    <div className="category-bg">
      <div className="category-inner">
        {children}
      </div>
    </div>
  );
}

export default CategoryShell;
